function ArticleCardContent({ children }) {
  return (
    <div className="space-y-1 md:space-y-2 text-black-primary">{children}</div>
  );
}

export { ArticleCardContent };
